module.exports = __webpack_public_path__ + "static/media/cinta-transportadora.12bd3e26.gif";